import { useSuspenseQueries, useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useIntl } from 'react-intl';
import { Head } from '@_/components';
import { getReactQueryOptions } from '@_/utils-frontend';
import { publicApiQueryClient } from '#src/api.ts';
import { BookingDetailsPage } from '#src/pages/BookingDetailsPage/index.ts';

export const Route = createFileRoute('/{-$locale}/_auth/booking_/$bookingId')({
  component: RouteComponent,
  loader: async ({ context, params }) => {
    const { queryClient } = context;
    const { bookingId } = params;
    await queryClient.ensureQueryData(bookingQueryOptions({ bookingId }));
  }
});

function RouteComponent() {
  const { bookingId } = Route.useParams();
  const intl = useIntl();

  const booking = useSuspenseQuery(bookingQueryOptions({ bookingId })).data.data;

  const [orderQuery, orderDetailedStateQuery] = useSuspenseQueries({
    queries: [orderQueryOptions(booking.orderId!), orderStateQueryOptions(booking.orderId!)]
  });

  const order = orderQuery.data.data;
  const orderDetailedState = orderDetailedStateQuery.data.data;

  return (
    <>
      <Head>
        <title>
          {intl.formatMessage({
            id: 'head.booking-details-page',
            defaultMessage: 'Your booking overview'
          })}
        </title>
      </Head>
      <BookingDetailsPage booking={booking} order={order} orderDetailedState={orderDetailedState} />
    </>
  );
}

function bookingQueryOptions({ bookingId }: { bookingId: string }) {
  return getReactQueryOptions(publicApiQueryClient.bookings.get, {
    params: { id: bookingId }
  });
}

function orderQueryOptions(orderId: string) {
  return getReactQueryOptions(publicApiQueryClient.orders.get, { params: { id: orderId } });
}

function orderStateQueryOptions(orderId: string) {
  return getReactQueryOptions(publicApiQueryClient.orders.getDetailedState, {
    params: { id: orderId }
  });
}
